export default "__VITE_ASSET__BWi3LqDd__"